<!--
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2021-11-08 18:52:46
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-04-11 11:35:45
-->
<template>
  <div class="index-introduction wh100">
    <div class="container wh100 flex">
      <div class="flex_2 posrel">
        <div class="ui-title">{{$t('frontPage.introduction.title')}}</div>
        <div class="ui-des textl">{{$t('frontPage.introduction.des')}}</div>
        <div class="swiper index-introduction-banner" id="indexIntroduction">
          <div class="swiper-wrapper" @mouseenter="mouseenter()" @mouseleave="mouseleave">
            <div class="swiper-slide" v-for="item in $t('frontPage.introduction.banner')" :key="item.id">
              <h3 class="slide-title" v-html="item.title"></h3>
              <div class="flex">
                <div class="slide-des-box textj">
                  <!-- <span class="slide-des" :class="{ multiLineText: language == 'en' }" v-for="($item, index) in item.des" :key="index" v-html="$item"></span> -->
                  <span class="slide-des" :class="{ multiLineText: language == 'en' && (clientWidth <= 1460 || clientHeight <= 900)}" v-for="($item, index) in item.des" :key="index" v-html="$item"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="swiper-pagination index-introduction-pagination"></div>
        </div>
        <div class="index-introduction-related">
          <div class="index-introduction-related-box flex align_items_center">
            <div class="related-item flex_1">
              <div class="related-item-num flex justify_content_center">
                <span>{{hospitals}}</span>
                <span>+</span>
              </div>
              <div>{{$t('frontPage.introduction.related.hospitals')}}</div>
            </div>
            <div class="related-item flex_1">
              <div class="related-item-num flex justify_content_center">
                <span>{{province}}</span>
                <span>+</span>
              </div>
              <div>{{$t('frontPage.introduction.related.province')}}</div>
            </div>
            <div class="related-item flex_1">
              <div class="related-item-num flex justify_content_center">
                <span>{{second}}</span>
                <span>min</span>
              </div>
              <div>{{$t('frontPage.introduction.related.second')}}</div>
            </div>
            <div class="related-item flex_1">
              <div class="related-item-num flex justify_content_center">
                <span>{{percentage}}</span>
                <span>%</span>
              </div>
              <div v-html="$t('frontPage.introduction.related.percentage')"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex_1">
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    realIndex: {
      type: Number,
      default: 0
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      hospitals: 0,
      province: 0,
      second: 100,
      percentage: 0
    }
  },
  computed: {
    ...mapGetters(['language', 'clientWidth', 'clientHeight'])
  },
  watch: {
    realIndex (newValue, oldValue) {
      if (newValue === this.activeIndex) {
        if (this.hospitals !== 300) {
          let timer = setInterval(() => {
            if (this.hospitals < 300) {
              this.hospitals += 10
            } else {
              this.hospitals = 300
              clearInterval(timer)
              timer = null
            }
          }, 100)
        }
        if (this.province !== 20) {
          let timer = setInterval(() => {
            if (this.province < 20) {
              this.province += 1
            } else {
              this.province = 20
              clearInterval(timer)
              timer = null
            }
          }, 100)
        }
        if (this.second !== 5) {
          let timer = setInterval(() => {
            if (Math.ceil(this.second) > 5) {
              this.second = Math.floor(Math.abs(this.second -= 2.5))
            } else {
              this.second = 5
              clearInterval(timer)
              timer = null
            }
          }, 100)
        }
        if (this.percentage !== 95) {
          let timer = setInterval(() => {
            if (this.percentage < 95) {
              this.percentage = Math.floor(Math.abs(this.percentage += 4.6))
            } else {
              this.percentage = 95
              clearInterval(timer)
              timer = null
            }
          }, 100)
        }
      } else {
        this.hospitals = 0
        this.province = 0
        this.second = 100
        this.percentage = 0
      }
    }
  },
  mounted () {
    this.mySwiper = new this.$Swiper('#indexIntroduction', {
      effect: 'flip',
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false
      },
      allowTouchMove: false,
      pagination: {
        el: '.index-introduction-pagination',
        bulletElement: 'li',
        clickable: true
      }
    })
  },
  methods: {
    mouseenter () {
      this.mySwiper && this.mySwiper.autoplay.stop()
    },
    mouseleave () {
      this.mySwiper && this.mySwiper.autoplay.start()
    }
  },
  beforeDestroy () { // 页面关闭时清除定时器
    this.mySwiper = null
  }
}
</script>

<style lang="less" scoped>
/*订单总量滚动数字设置*/
 .box-item {
  position: relative;
  height: 100PX;
  font-size: 54PX;
  line-height: 41PX;
  text-align: center;
  list-style: none;
  color: #2D7CFF;
  writing-mode: vertical-lr;
  text-orientation: upright;
  /*文字禁止编辑*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  /* overflow: hidden; */
 }
 /* 默认逗号设置 */
 .mark-item {
  width: 10PX;
  height: 100PX;
  margin-right: 5PX;
  line-height: 10PX;
  font-size: 48PX;
  position: relative;
  & > span {
   position: absolute;
   width: 100%;
   bottom: 0;
   writing-mode: vertical-rl;
   text-orientation: upright;
  }
 }
 /*滚动数字设置*/
 .number-item {
  width: 41PX;
  height: 75PX;
  background: #ccc;
  list-style: none;
  margin-right: 5PX;
  background:rgba(250,250,250,1);
  border-radius:4PX;
  border:1PX solid rgba(221,221,221,1);
  & > span {
   position: relative;
   display: inline-block;
   margin-right: 10PX;
   width: 100%;
   height: 100%;
   writing-mode: vertical-rl;
   text-orientation: upright;
   overflow: hidden;
   & > i {
    font-style: normal;
    position: absolute;
    top: 11PX;
    left: 50%;
    transform: translate(-50%,0);
    transition: transform 1s ease-in-out;
    letter-spacing: 10PX;
   }
  }
 }
 .number-item:last-child {
  margin-right: 0;
 }
</style>

<style lang="less" scoped>
.pc .index-introduction {
  background-image: url(../../../../../assets/images/pc/index/introduction.gif);
  background-repeat: no-repeat;
  background-position: right top;
  background-size: auto 100%;
  background-color: #F3F3F3;
  padding-top: 90PX;
  .ui-title {
    display: inline-block;
    padding-top: 44PX;
    &::before {
      left: 0;
    }
  }
  .index-introduction-banner {
    width: 48vw;
    margin: 0;
    position: relative;
    top: 12%;
    .swiper-wrapper {
      width: 30vw;
    }
    .swiper-slide {
      width: 30vw;
      opacity: 0;
      color: #333333;
      font-size: 14PX;
      line-height: 20PX;
      background-color: #F3F3F3;
      padding: 10PX 0;
      &.swiper-slide-active {
        opacity: 1;
      }
      .slide-title {
        font-size: 26PX;
        font-weight: bold;
        padding-bottom: 30PX;
      }
      .slide-des-box {
        overflow: hidden;
        word-break: inherit;
        line-height: 1.5em;
        color: #000000;
        font-size: 16PX;
        &::before{
          content: '';
          float: right;
          width: 0;
          height: 100%;
          margin-bottom: -1.5em;
        }
      }
      .slide-more {
        color: #00A0E9;
        float: right;
        margin-top: 4PX;
        clear: both;
        position: relative;
        right: 10PX;
        &::before{
          content: '...';
          position: absolute;
          left: 14PX;
          color: #000000;
          transform: translateX(-100%)
        }
      }
    }
  }
  .index-introduction-related {
    position: absolute;
    bottom: 12%;
    width: 110%;
    z-index: 2;
    .index-introduction-related-box {
      background: #ffffff;
      height: 160PX;
      text-align: center;
      color: #333333;
      font-size: 14PX;
    }
    .related-item {
      .related-item-num {
        font-size: 30PX;
        font-weight: bold;
        padding-bottom: 10PX;
      }
    }
  }
}

.pc.en .index-introduction {
  .index-introduction-banner {
    .swiper-slide {
      .slide-des-box {
        // max-height: 4.5em;
      }
    }
  }
}
</style>

<style lang="less">
.pc .index-introduction {
    .index-introduction-pagination {
      position: absolute;
      bottom: -30PX;
      text-align: left;
      .swiper-pagination-bullet {
        background: #00A0E9;
        margin-right: 34PX;
        width: 12PX;
        height: 12PX;
        &.swiper-pagination-bullet-active {
          background: #00A0E9;
        }
      }
    }
}
</style>
<style lang="less" scoped>
@media screen and (max-width: 1700PX)  and (min-width: 1600PX) {
  .pc.en .index-introduction {
    .index-introduction-banner {
      top: 10%;
    }
    .index-introduction-related {
      bottom: 7.4%;
      width: 120%;
      .index-introduction-related-box {
        height: 140PX;
      }
    }
  }
}
@media screen and (max-width: 1600PX)  and (min-width: 1400PX) {
  .pc .index-introduction {
    .index-introduction-banner {
      top: 10%;
    }
    .index-introduction-related {
      bottom: 7.4%;
      width: 120%;
      .index-introduction-related-box {
        height: 120PX;
      }
    }
  }
}
@media screen and (max-width: 1400PX) and (min-width: 1366PX) {
  .pc .index-introduction {
    background-position: right -18% top;
    background-size: 46% 100%;
    .ui-title {
      padding-top: 44PX;
    }
    .index-introduction-related {
      bottom: 10%;
      width: 110%;
    }
  }
}
@media screen and (max-width: 1366PX) {
  .pc .index-introduction {
    padding-top: 30PX;
    .index-introduction-banner {
      top: 6%;
    }
    background-position: right top;
    background-size: auto 100%;
    font-size: 12PX;
    .ui-title {
      padding-top: 30PX;
    }
    .index-introduction-related {
      bottom: 5%;
      width: 110%;
      .index-introduction-related-box {
        height: 100PX;
      }
      .related-item {
        .related-item-num{
          font-size: 22PX;
        }
      }
    }
  }
}

@media screen and (width: 1280PX) and (max-height: 960PX) and (min-height: 620PX) {
  .pc .index-introduction {
    padding-top: 60PX;
    .index-introduction-banner {
      top: 8%;
    }
    .index-introduction-related {
      bottom: 8%;
    }
  }
}

@media screen and (width: 1280PX) and (min-height: 800PX) {
  .pc .index-introduction {
    padding-top: 90PX;
    background-position: right -10% top;
    .ui-title {
      padding-top: 60PX;
    }
    .index-introduction-related {
      bottom: 15%;
    }
  }
}
@media screen and (max-height: 500PX) {
  .pc .index-introduction {
    font-size: 12PX;
    padding-top: 60PX;
    .ui-title {
      padding-top: 0;
    }
    .index-introduction-banner {
      top: 6%;
    }
    .index-introduction-related {
      bottom: 4%;
      .index-introduction-related-box {
        height: 80PX;
      }
      .related-item {
        .related-item-num{
          font-size: 20PX;
        }
      }
    }
  }
}
@media screen and (max-width: 1152PX) {
  .pc .index-introduction {
    padding-top: 90PX;
    background-position: right -10% top;
    .ui-des {
      width: 90%;
    }
    .index-introduction-related {
      bottom: 10%;
    }
  }
}

@media screen and (max-width: 1460PX)  and (max-height: 900PX) {
  .pc.en .index-introduction {
    .index-introduction-banner {
      .swiper-slide {
        .slide-des-box {
          max-height: 4.5em;
        }
      }
    }
  }
}
</style>
